import { isLockerDevice } from 'library/helpers/deviceFamily';

/**
 * Lockers are a SEPARATE PRODUCT, and most Access surfaces do not surface them.
 *
 * A locker's hardware is lock hardware — BOOKEABLE_LOCKERS (14/19) sits inside
 * CONTROL_DEVICE_CATEGORIES — so every Access surface that buckets by "locks" silently
 * swallowed lockers and counted them as its own. Filter an Access list, count or
 * breakdown with `withoutLockers`; the Lockers shell reads the unfiltered store.
 *
 * 🛑 The ACCESS DEVICES GRID (/access/devices) is the deliberate exception: it lists
 * lockers under a Lockers tab of their own, gated on the Locker module. Lockers stay out
 * of Access PERMISSIONS — see selectAccessGrantingDevices.
 *
 * ⚠️ This is about DEVICES, not the Lockers PRODUCT. Portfolio surfaces answering "which
 * products does this site run" (product pills, useSiteRollups) must keep looking at
 * locker devices — that is how the entitlement is detected. Filter lists, not entitlement.
 */

/** A device list with lockers removed — for Access-product lists and counts. */
export const withoutLockers = (devices) => (devices || []).filter((d) => !isLockerDevice(d));
